import { RemoveRedEye } from "@mui/icons-material";
import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { reportdateFormat } from "utils";
import EditIcon from "@mui/icons-material/Edit";
import ModalBox from "components/modal/ModalBox";
import { Input, TextArea } from "components/Form";
import {
  addCategory,
  getCategoryByID,
  getCategoryList,
  updateCategory,
  updateStatusOfCategory,
} from "services/categorymanagement";

export default function CategoryManagementList() {
  const [record, setRecord] = useState([]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getCategoryList({
        page: activePage,
        search: search,
        limit: limit,
      });
      // console.log(res)
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.categories;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
        setSelectedId("");
      } else {
        toast.error(res.message);
        setSelectedId("");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  // ************************************** Fetch Data By Id  **********************************************
  const fetchData = async (id) => {
    showLoader();
    try {
      const res = await getCategoryByID({
        id: id,
      });
      // console.log(res)
      hideLoader();
      if (res.code === 200) {
        const { id, categoryname, categorydescription, status, addedon } =
          res.data;
        setData({
          ...data,
          name: categoryname || "",
          description: categorydescription || "",
        });
        setSelectedId(id);
      } else {
        toast.error(res.message);
        setSelectedId("");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  // ************************************* Update Status ***************************************
  const handleCategoryStatus = async () => {
    showLoader();
    setSubmitLoading(true);
    try {
      const res = await updateStatusOfCategory({
        id: selectedId,
      });
      hideLoader();
      setSubmitLoading(false);
      if (res.code === 200) {
        setSubmitLoading(false);
        setStatusModal(false);
        fetchRecord();
        toast.success(res.message);
      } else {
        setSubmitLoading(false);
        setStatusModal(false);
        fetchRecord();
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
    setSubmitLoading(false);
  };

  // ************************************** Handle Validation ************************************************
  const handleValidation = () => {
    const errors = {};

    if (!data.name) {
      errors.name = "Please Enter Category Name";
    }
    // if (!data.description) {
    //   errors.description = "Please Enter Category Description";
    // }

    setErrorField(errors);
    return Object.keys(errors).length === 0;
  };

  // ************************************* Add Category ***************************************
  const handleAddCategory = async () => {
    showLoader();
    setSubmitLoading(true);
    try {
      if (handleValidation()) {
        const res = await addCategory({
          categoryname: data.name,
          categorydescription: data.description,
        });
        hideLoader();
        setSubmitLoading(false);
        if (res.code === 200) {
          setSubmitLoading(false);
          setAddModal(false);
          fetchRecord();
          toast.success(res.message);
        } else {
          setSubmitLoading(false);
          setAddModal(false);
          fetchRecord();
          toast.error(res.message);
        }
      } else {
        toast.error("Please Enter All Fields");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
    setSubmitLoading(false);
  };

  // ************************************* Update Category ***************************************
  const handleEditCategory = async () => {
    console.log(selectedId);
    
    showLoader();
    setSubmitLoading(true);
    try {
      if (handleValidation()) {
        const res = await updateCategory({
          id: selectedId,
          categoryname: data.name,
          categorydescription: data.description,
        });
        hideLoader();
        setSubmitLoading(false);
        if (res.code === 200) {
          setSubmitLoading(false);
          setEditModal(false);
          fetchRecord();
          toast.success(res.message);
        } else {
          setSubmitLoading(false);
          setEditModal(false);
          fetchRecord();
          toast.error(res.message);
        }
      } else {
        toast.error("Please Enter All Fields");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
    setSubmitLoading(false);
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div className="div_wrap mx-1 w40per"></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button
                      onClick={() => {
                        setData({ ...data, name: "", description: "" });
                        setErrorField({
                          ...errorField,
                          name: "",
                          description: "",
                        });
                        setAddModal(true);
                      }}
                    >
                      Add&nbsp;Category
                    </Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">Category Management</h4>
            </div>

            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th className="border-right">S.No</th>
                    <th className="border-right">Category Name</th>
                    <th className="border-right text-center">
                      Category Description
                    </th>
                    <th className="border-right text-center">Status</th>
                    <th className="text-center ">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          categoryname,
                          categorydescription,
                          status,
                          addedon,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td className="w100px">
                            {++i + (activePage - 1) * limit}
                          </td>
                          <td>{categoryname}</td>
                          <td className="w200px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    fetchData(id);
                                    setViewModal(true);
                                  }}
                                >
                                  <RemoveRedEye sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <Switch
                                checked={status}
                                onChange={() => {
                                  setSelectedId(id || "");
                                  setStatusModal(true);
                                }}
                              />
                            </div>
                          </td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    setData({
                                      ...data,
                                      name: "",
                                      description: "",
                                    });
                                    setSelectedId(id)
                                    fetchData(id);
                                    setErrorField({
                                      ...errorField,
                                      name: "",
                                      description: "",
                                    });
                                    setEditModal(true);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* ***********************************  Add Category ****************************************** */}
      <ModalBox
        status={addModal}
        onClose={() => setAddModal(false)}
        size={"sm"}
        title={"Add Category"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-sm-12 col-form-label">
                            <Input
                              type="text"
                              name="name"
                              value={data.name}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({ ...data, [name]: value });
                              }}
                              placeholder="Enter Category Name"
                              className={`form-control `}
                              maxLength={30}
                              label="Name"
                              error={errorField.name}
                              required
                            />
                          </div>
                          <div className="col-sm-12 col-form-label">
                            <TextArea
                              type="text"
                              name="description"
                              value={data.description}
                              placeholder="Enter Category Description"
                              className={`form-control `}
                              rows={4}
                              label={"Description"}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({
                                  ...data,
                                  [name]: value,
                                });
                              }}
                              // error={errorField.description}
                              // required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        custom={true}
        customizedFooter={
          <>
            <Button onClick={() => setAddModal(false)} {...submitButtonElement}>
              Cancel
            </Button>
            <Button onClick={handleAddCategory} {...submitButtonElement}>
              Add
            </Button>
          </>
        }
        // Close={true}
        // custom={false}
      />

      {/* ***********************************  Edit Category ****************************************** */}
      <ModalBox
        status={editModal}
        onClose={() => setEditModal(false)}
        size={"sm"}
        title={"Update Category"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-sm-12 col-form-label">
                            <Input
                              type="text"
                              name="name"
                              value={data.name}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({ ...data, [name]: value });
                              }}
                              placeholder="Enter Category Name"
                              className={`form-control `}
                              maxLength={30}
                              label="Name"
                              error={errorField.name}
                              required
                            />
                          </div>
                          <div className="col-sm-12 col-form-label">
                            <TextArea
                              type="text"
                              name="description"
                              value={data.description}
                              placeholder="Enter Category Description"
                              className={`form-control `}
                              rows={4}
                              label={"Description"}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({
                                  ...data,
                                  [name]: value,
                                });
                              }}
                              // error={errorField.description}
                              // required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        custom={true}
        customizedFooter={
          <>
            <Button
              onClick={() => setEditModal(false)}
              {...submitButtonElement}
            >
              Cancel
            </Button>
            <Button onClick={handleEditCategory} {...submitButtonElement}>
              Update
            </Button>
          </>
        }
        // Close={true}
        // custom={false}
      />

      {/* ***********************************  View Description ****************************************** */}
      <ModalBox
        status={viewModal}
        onClose={() => setViewModal(false)}
        size={"sm"}
        title={"View Description"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-sm-12 col-form-label">
                            <textarea
                              type="text"
                              readonly
                              disabled={true}
                              name="description"
                              value={data.description}
                              placeholder="Enter Category Description"
                              className={`form-control `}
                              rows={4}
                              label={"Description"}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({
                                  ...data,
                                  [name]: value,
                                });
                              }}
                              // error={errorField.description}
                              // required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={true}
        Close={true}
        custom={false}
      />

      {/* ***********************************  Update Status Of Category ****************************************** */}
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={"Change Status"}
        description={"Are you sure? You want to change status"}
        customizedFooter={
          <>
            <Button onClick={handleCategoryStatus} {...submitButtonElement}>
              Yes
            </Button>
          </>
        }
        // Close={true}
        // custom={false}
      />
    </>
  );
}
